import { Placeholder } from "./Placeholder";
import { useReveal } from "../hooks/useReveal";
import { IMG } from "../lib/images";
import { useLanguage } from "../lib/LanguageContext";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const Gallery = () => {
  const ref = useReveal();
  const { t } = useLanguage();

  const photos = [
    {
      src: IMG.poolSunloungers,
      label: t("gal_pool"),
      caption: t("gal_pool_c"),
      span: "md:col-span-2 md:row-span-2",
      h: "h-[260px] md:h-[560px]",
    },
    {
      src: IMG.livingRoom,
      label: t("gal_apt"),
      caption: t("gal_apt_c"),
      span: "md:col-span-2",
      h: "h-[260px]",
    },
    {
      src: IMG.terraceStone,
      label: t("gal_balcony"),
      caption: t("gal_balcony_c"),
      span: "",
      h: "h-[260px]",
    },
    {
      src: IMG.villaSign,
      label: t("gal_garden"),
      caption: t("gal_garden_c"),
      span: "",
      h: "h-[260px]",
    },
    {
      src: IMG.livingArches,
      label: t("gal_interior"),
      caption: t("gal_interior_c"),
      span: "md:col-span-2",
      h: "h-[260px]",
    },
    {
      src: IMG.twinRoomBlue,
      label: t("gal_twin"),
      caption: t("gal_twin_c"),
      span: "",
      h: "h-[260px]",
      position: "center 30%",
    },
    {
      src: IMG.twinRoomDoor,
      label: t("gal_twin"),
      caption: t("gal_twin_door_c"),
      span: "",
      h: "h-[260px]",
    },
    {
      src: IMG.aerialProperty,
      label: t("gal_coast"),
      caption: t("gal_coast_c"),
      span: "md:col-span-2",
      h: "h-[260px]",
    },
  ];

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-36 bg-[#f3efe6]"
    >
      <div ref={ref} className="reveal max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="text-[10px] uppercase tracking-[0.28em] text-[#6b705c] mb-6">
              {t("gal_eyebrow")}
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-[#0a192f] leading-[1.02]">
              {t("gal_title_a")}{" "}
              <em className="italic text-[#1a5b73]">{t("gal_title_b")}</em>.
            </h2>
          </div>
          <p className="md:max-w-xs text-[#4a4a4a] font-light">{t("gal_intro")}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[260px] gap-4 md:gap-5">
          {photos.map((p, i) => (
            <Placeholder
              key={i}
              src={p.src}
              alt={p.caption}
              label={p.label}
              caption={p.caption}
              position={p.position || "center"}
              testId={`gallery-tile-${i}`}
              className={`${p.span} ${p.h}`}
            />
          ))}
        </div>

        <div className="mt-12 md:mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border-t border-[#0a192f]/10 pt-10">
          <p className="text-[#4a4a4a] font-light max-w-md">
            Want to see more? Browse the full collection of photos from the
            pool, apartments, gardens and bedrooms.
          </p>
          <Link
            to="/gallery"
            data-testid="view-full-gallery"
            className="group inline-flex items-center gap-3 bg-[#1a5b73] hover:bg-[#134456] text-white px-8 py-4 rounded-full text-[12px] uppercase tracking-[0.22em] font-medium transition-colors"
          >
            View full gallery
            <ArrowUpRight
              className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
              strokeWidth={1.5}
            />
          </Link>
        </div>
      </div>
    </section>
  );
};
